import { render, staticRenderFns } from "./NoBillingAccess.vue?vue&type=template&id=4daa47b6"
import script from "./NoBillingAccess.vue?vue&type=script&lang=js"
export * from "./NoBillingAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports